import { useState, useEffect, useCallback } from "react";
import { DICT, RTL_LANGS, LANGS } from "./prod";

const KEY = "bsm_prod_lang";
const EVT = "bsm-prod-lang-change";
const VALID = LANGS.map((l) => l.code);
const read = () => { const v = localStorage.getItem(KEY); return VALID.includes(v) ? v : "da"; };

export function useProdLang() {
  const [lang, setLangState] = useState(read);

  useEffect(() => {
    const onChange = () => setLangState(read());
    window.addEventListener(EVT, onChange);
    return () => window.removeEventListener(EVT, onChange);
  }, []);

  const setLang = useCallback((code) => {
    localStorage.setItem(KEY, code);
    window.dispatchEvent(new Event(EVT));
  }, []);

  const t = useCallback((key) => (DICT[lang] && DICT[lang][key]) || DICT.da[key] || key, [lang]);
  const dir = RTL_LANGS.includes(lang) ? "rtl" : "ltr";

  return { lang, setLang, t, dir };
}
